import { render } from "./BusinessSubscriptions.vue?vue&type=template&id=0e45b73e"
import script from "./BusinessSubscriptions.vue?vue&type=script&lang=js"
export * from "./BusinessSubscriptions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__